import React from 'react';
import {telemetrySendError} from '@packages/systems/designer/canvas';
import {getDesignerAppOrigin} from '@packages/utilities/canvas-origin';

const EXPECTED_CANVAS_APP_LOADING_TIMEOUT = 10000; // 10 seconds

/**
 * Reports back to Designer App that Canvas App has loaded with white screen.
 */
export const useReportCanvasLoadedWithWhiteScreen = () => {
  // For now let's assume we don't want to report for users in read-only mode
  const designerAppOrigin = getDesignerAppOrigin(window.location.origin);

  // run only once after initial render occurred
  React.useEffect(() => {
    setTimeout(() => {
      // currently when we observe "white screen" body element is missing in the document, so we use it as a signal that something went wrong
      if (!document.body) {
        telemetrySendError({
          name: 'Body never rendered',
          error: new Error('Body never rendered'),
        });
      }
    }, EXPECTED_CANVAS_APP_LOADING_TIMEOUT);
    // Note: we intentionally are not cancelling timeout on the component dismount as in case of error component will dismount,
    // and no error will be reported.
    // Based on the HTML Standard (https://html.spec.whatwg.org/multipage/iframe-embed-object.html#the-iframe-element) when an iframe is removed from the DOM,
    // its associated document and JavaScript execution context are destroyed. So if user will navigate away from view with Canvas app
    // this timeout will be cancelled.
  }, [designerAppOrigin]);
};
